export enum MessageTypeEnum {
    Transmitter,
    Process,
    Sensor,
    Request,
    MonData,
    Notification
}
